import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getSelectedBundleId } from '../work-items-db/work-items-db.query';
import * as fromMasterData from './master-data-db.reducer';

export const selectMasterData = createFeatureSelector<fromMasterData.TMasterDataDatabases>('masterDataDB');

export const isMasterDataDBReady = createSelector(selectMasterData, (masterData) => {
  return masterData.result.length;
});

export const selectAllBundles = createSelector(selectMasterData, (masterData) => {
  return masterData.entities['BUNDLES'];
});
export const selectMasterDataMapByBundleId = createSelector(
  getSelectedBundleId,
  selectAllBundles,
  (bundleId, masterBundle) => {
    console.log('selectDefectsInfo', bundleId, masterBundle);
    if (bundleId) {
      const bundleConfig = masterBundle[bundleId] && masterBundle[bundleId].data;
      const defaultConfig = masterBundle['default'].data;

      if (bundleConfig && defaultConfig) {
        return {
          ...defaultConfig,
          ...bundleConfig,
        };
      }
    }
    return {};
  },
);
